import { httpPost } from './request/index'

// 投递订单记录
export function orderList (data) {
  return httpPost('/data/deliveryRecord', data)
}
// 设备管理 > 设备运营记录 > 补货记录
export function findReplenishmentList (data) {
  return httpPost('/replenishment/findReplenishmentList ', data)
}
// 设备管理 > 设备运营记录 > 补货记录 - 统计
export function getGoodsCount (data) {
  return httpPost('/replenishment/getGoodsCount ', data)
}
// 设备管理 > 设备运营记录 > 补货记录 - 详情
export function detail (data) {
  return httpPost('/replenishment/detail ', data)
}

// 设备管理 > 智能设备管理 > 兑换机管理 - 详情
export function exchangeConfig (id) {
  const data = {
    id
  }
  return httpPost('wheat/getDetail', data)
}

// 设备管理 > 分类设备健康 > 数量
export function getHealthyCount (data) {
  return httpPost('/product/getHealthyCount', data)
}
// 设备管理 > 分类设备健康 > 列表
export function getHealthyList (data) {
  return httpPost('/product/getHealthyList', data)
}

// 设备管理 > 分类设备健康 > 列表详情
export function getyHealthyDetail (data) {
  return httpPost('/product/getyHealthyDetail', data)
}

// 设备运维 > 设备远程信息管理 - 设备通断表格数据
export function list (data) {
  return httpPost('/product/breaking/list', data)
}

// 设备运维 > 设备远程信息管理 - 设备通断 操作设备
export function operateDevice (data) {
  return httpPost('/product/breaking/operateDevice', data)
}

// 设备运维 > 设备远程信息管理 - 设备通断 批量处理设备
export function batchOperateDevice (data) {
  return httpPost('/product/breaking/batchOperateDevice', data)
}

// 智能售后> 环境精灵数据
export function getPerceptionData (data) {
  return httpPost('/product/getPerceptionData', data)
}

// 设备运维 > 设备远程信息管理 - 端口图片远程配置 - 表格数据
export function getList (data) {
  return httpPost('/image/getList', data)
}
